import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4fea7b41 = () => interopDefault(import('../pages/cart.vue' /* webpackChunkName: "pages/cart" */))
const _41183ed4 = () => interopDefault(import('../pages/compare.vue' /* webpackChunkName: "pages/compare" */))
const _5c1c108f = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _55ac48ac = () => interopDefault(import('../pages/dealers/index.vue' /* webpackChunkName: "pages/dealers/index" */))
const _181ac91d = () => interopDefault(import('../pages/downloads/index.vue' /* webpackChunkName: "pages/downloads/index" */))
const _9b449d1e = () => interopDefault(import('../pages/ecuwizard.vue' /* webpackChunkName: "pages/ecuwizard" */))
const _34523ec8 = () => interopDefault(import('../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _641436d9 = () => interopDefault(import('../pages/hall-of-fame/index.vue' /* webpackChunkName: "pages/hall-of-fame/index" */))
const _6e8491c8 = () => interopDefault(import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _b23d648c = () => interopDefault(import('../pages/reset-password.vue' /* webpackChunkName: "pages/reset-password" */))
const _19e8ffb6 = () => interopDefault(import('../pages/sandbox.vue' /* webpackChunkName: "pages/sandbox" */))
const _2f2ec168 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _2d3a6dbe = () => interopDefault(import('../pages/training/index.vue' /* webpackChunkName: "pages/training/index" */))
const _fa822572 = () => interopDefault(import('../pages/version.vue' /* webpackChunkName: "pages/version" */))
const _376db4c4 = () => interopDefault(import('../pages/downloads/special.vue' /* webpackChunkName: "pages/downloads/special" */))
const _d82161a2 = () => interopDefault(import('../pages/products/engine-management/targeted-range/atv.vue' /* webpackChunkName: "pages/products/engine-management/targeted-range/atv" */))
const _07cf7df6 = () => interopDefault(import('../pages/products/engine-management/targeted-range/bike.vue' /* webpackChunkName: "pages/products/engine-management/targeted-range/bike" */))
const _66609da2 = () => interopDefault(import('../pages/products/engine-management/targeted-range/category.vue' /* webpackChunkName: "pages/products/engine-management/targeted-range/category" */))
const _4af83f66 = () => interopDefault(import('../pages/products/engine-management/targeted-range/marine.vue' /* webpackChunkName: "pages/products/engine-management/targeted-range/marine" */))
const _2bfd6fc8 = () => interopDefault(import('../pages/products/engine-management/targeted-range/other.vue' /* webpackChunkName: "pages/products/engine-management/targeted-range/other" */))
const _32cf1609 = () => interopDefault(import('../pages/products/engine-management/targeted-range/snowmobile.vue' /* webpackChunkName: "pages/products/engine-management/targeted-range/snowmobile" */))
const _1f871d38 = () => interopDefault(import('../pages/products/engine-management/targeted-range/vehicle.vue' /* webpackChunkName: "pages/products/engine-management/targeted-range/vehicle" */))
const _775309df = () => interopDefault(import('../pages/products/engine-management/targeted-package/_slug.vue' /* webpackChunkName: "pages/products/engine-management/targeted-package/_slug" */))
const _ef1f509a = () => interopDefault(import('../pages/products/category/_slug.vue' /* webpackChunkName: "pages/products/category/_slug" */))
const _19240e24 = () => interopDefault(import('../pages/products/category/_catslug/_slug.vue' /* webpackChunkName: "pages/products/category/_catslug/_slug" */))
const _145b87b6 = () => interopDefault(import('../pages/dealer/_id.vue' /* webpackChunkName: "pages/dealer/_id" */))
const _1b715330 = () => interopDefault(import('../pages/faq/_id.vue' /* webpackChunkName: "pages/faq/_id" */))
const _625d9591 = () => interopDefault(import('../pages/hall-of-fame/_slug.vue' /* webpackChunkName: "pages/hall-of-fame/_slug" */))
const _6ccdf080 = () => interopDefault(import('../pages/products/_slug.vue' /* webpackChunkName: "pages/products/_slug" */))
const _3f5ecb23 = () => interopDefault(import('../pages/site/_slug.vue' /* webpackChunkName: "pages/site/_slug" */))
const _2b83cc76 = () => interopDefault(import('../pages/training/_slug.vue' /* webpackChunkName: "pages/training/_slug" */))
const _7330f601 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/cart",
    component: _4fea7b41,
    name: "cart"
  }, {
    path: "/compare",
    component: _41183ed4,
    name: "compare"
  }, {
    path: "/contact",
    component: _5c1c108f,
    name: "contact"
  }, {
    path: "/dealers",
    component: _55ac48ac,
    name: "dealers"
  }, {
    path: "/downloads",
    component: _181ac91d,
    name: "downloads"
  }, {
    path: "/ecuwizard",
    component: _9b449d1e,
    name: "ecuwizard"
  }, {
    path: "/faq",
    component: _34523ec8,
    name: "faq"
  }, {
    path: "/hall-of-fame",
    component: _641436d9,
    name: "hall-of-fame"
  }, {
    path: "/products",
    component: _6e8491c8,
    name: "products"
  }, {
    path: "/reset-password",
    component: _b23d648c,
    name: "reset-password"
  }, {
    path: "/sandbox",
    component: _19e8ffb6,
    name: "sandbox"
  }, {
    path: "/search",
    component: _2f2ec168,
    name: "search"
  }, {
    path: "/training",
    component: _2d3a6dbe,
    name: "training"
  }, {
    path: "/version",
    component: _fa822572,
    name: "version"
  }, {
    path: "/downloads/special",
    component: _376db4c4,
    name: "downloads-special"
  }, {
    path: "/products/engine-management/targeted-range/atv",
    component: _d82161a2,
    name: "products-engine-management-targeted-range-atv"
  }, {
    path: "/products/engine-management/targeted-range/bike",
    component: _07cf7df6,
    name: "products-engine-management-targeted-range-bike"
  }, {
    path: "/products/engine-management/targeted-range/category",
    component: _66609da2,
    name: "products-engine-management-targeted-range-category"
  }, {
    path: "/products/engine-management/targeted-range/marine",
    component: _4af83f66,
    name: "products-engine-management-targeted-range-marine"
  }, {
    path: "/products/engine-management/targeted-range/other",
    component: _2bfd6fc8,
    name: "products-engine-management-targeted-range-other"
  }, {
    path: "/products/engine-management/targeted-range/snowmobile",
    component: _32cf1609,
    name: "products-engine-management-targeted-range-snowmobile"
  }, {
    path: "/products/engine-management/targeted-range/vehicle",
    component: _1f871d38,
    name: "products-engine-management-targeted-range-vehicle"
  }, {
    path: "/products/engine-management/targeted-package/:slug?",
    component: _775309df,
    name: "products-engine-management-targeted-package-slug"
  }, {
    path: "/products/category/:slug?",
    component: _ef1f509a,
    name: "products-category-slug"
  }, {
    path: "/products/category/:catslug?/:slug?",
    component: _19240e24,
    name: "products-category-catslug-slug"
  }, {
    path: "/dealer/:id?",
    component: _145b87b6,
    name: "dealer-id"
  }, {
    path: "/faq/:id",
    component: _1b715330,
    name: "faq-id"
  }, {
    path: "/hall-of-fame/:slug?",
    component: _625d9591,
    name: "hall-of-fame-slug"
  }, {
    path: "/products/:slug",
    component: _6ccdf080,
    name: "products-slug"
  }, {
    path: "/site/:slug?",
    component: _3f5ecb23,
    name: "site-slug"
  }, {
    path: "/training/:slug",
    component: _2b83cc76,
    name: "training-slug"
  }, {
    path: "/",
    component: _7330f601,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
